module.exports = __webpack_public_path__ + "img/m_img.a0187218.png";